// frontend/src/app/services/trial.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';

/**
 * Intercepte les réponses 403 TRIAL_EXPIRED, SUBSCRIPTION_BLOCKED et SUBSCRIPTION_PAUSED du backend
 * et redirige l'utilisateur vers la page d'abonnement.
 * Retourne EMPTY pour éviter que les erreurs polluent la console.
 */
export const TrialInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      // Ne pas rediriger pendant l'onboarding, ni depuis « Mon profil » : un compte à l'essai expiré
      // ou en pause doit pouvoir y supprimer son compte (BUG-04, D-10)
      if (
        router.url.startsWith('/onboarding') ||
        router.url.startsWith('/profile')
      ) {
        return throwError(() => error);
      }

      if (error.status === 403) {
        const code = error.error?.code;
        const isStringMatch =
          typeof error.error === 'string' &&
          (error.error.includes('TRIAL_EXPIRED') ||
            error.error.includes('SUBSCRIPTION_BLOCKED'));

        if (code === 'TRIAL_EXPIRED' || (!code && isStringMatch)) {
          router.navigate(['/subscription'], {
            queryParams: { reason: 'trial_expired' },
          });
          return EMPTY;
        }

        if (code === 'SUBSCRIPTION_PAUSED') {
          router.navigate(['/subscription'], {
            queryParams: { reason: 'paused' },
          });
          return EMPTY;
        }

        if (code === 'SUBSCRIPTION_BLOCKED') {
          router.navigate(['/subscription'], {
            queryParams: { reason: 'payment_failed' },
          });
          return EMPTY;
        }
      }
      return throwError(() => error);
    }),
  );
};
